var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgL06 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 268.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-2012.00, 0.00)",
    id: "L6_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2272.87,115.50 C2271.43,111.43 2264.19,97.92 2259.80,91.12 C2257.22,87.16 2252.46,81.54 2249.32,78.79 C2246.18,76.09 2238.86,71.37 2234.76,69.41 C2228.98,66.68 2214.70,63.12 2207.32,62.13 C2199.92,61.16 2187.00,60.61 2174.51,60.62 C2166.13,60.74 2149.71,61.11 2141.67,61.37 C2130.11,61.92 2116.93,63.35 2108.48,64.44 C2100.28,65.66 2081.41,69.10 2077.23,70.26 C2070.04,72.29 2057.30,78.20 2051.42,82.22 C2046.54,85.60 2036.87,96.15 2033.02,102.01 C2029.19,107.88 2022.87,121.57 2020.63,129.13 C2018.38,136.83 2015.51,154.77 2015.15,163.48 C2014.98,167.70 2015.68,184.28 2016.28,191.64 C2017.09,199.23 2019.35,215.04 2020.79,223.28 C2022.44,231.63 2026.30,248.02 2028.51,256.03 C2030.92,263.93 2036.29,279.38 2039.25,286.93 C2041.62,292.75 2050.54,310.45 2054.90,318.06 C2059.37,325.59 2069.08,340.15 2074.32,347.17 C2080.28,354.92 2089.79,365.96 2094.67,370.80 C2099.55,375.61 2110.08,384.07 2115.39,386.68 C2119.52,388.69 2127.76,390.94 2131.65,391.12 C2135.61,391.25 2141.95,389.87 2146.48,388.13 C2153.83,385.25 2167.34,378.08 2171.82,374.47 C2177.48,369.87 2186.44,360.87 2190.98,355.22 C2203.26,339.56 2212.78,325.62 2227.20,303.21 C2231.61,296.30 2240.66,282.06 2245.12,274.76 C2249.26,267.60 2256.66,253.66 2259.77,246.96 C2263.37,238.99 2268.64,223.37 2270.47,214.76 C2272.28,206.08 2273.23,190.30 2273.65,182.57 C2274.12,175.63 2275.09,162.31 2275.48,153.27 C2275.87,145.59 2276.59,130.86 2275.03,123.47 C2274.63,121.60 2273.38,116.96 2272.87,115.50 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL06, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L-06.61bf8ab2.svg";
export { ForwardRef as ReactComponent };